module.exports = __webpack_public_path__ + "static/img/article_02.b62c1ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2024/galaxy_award/article_02.png
// module id = jy0M
// module chunks = 0